export default __webpack_public_path__ + "0debae66ba5f03a87f96f1d1485bf8cf.svg";